
import { useState, useRef } from "react"

export default function Contact() {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [isSubmitted, setIsSubmitted] = useState(false)

  const form = useRef()

  const handleSubmit = async (e) => {
  e.preventDefault();

  const res = await fetch("/api/contact", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name,
      email,
      message,
    }),
  });

  if (res.ok) {
    setIsSubmitted(true);
  } else {
    alert("Failed to send message");
  }
};


  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <div className="text-green-600 text-4xl mb-4">✓</div>
          <h3 className="text-xl font-bold mb-2">Message sent!</h3>
          <p className="text-gray-600">Thank you for contacting us.</p>
        </div>
      </div>
    )
  }
return (
  <div className="relative min-h-screen flex items-center justify-center p-6">
    <div 
      className="absolute inset-0 bg-cover bg-center opacity-50"
      style={{ backgroundImage: "url('/assets/produce3.jpg')" }}
    ></div>

    <div className="absolute inset-0 bg-black opacity-20"></div>

    <div className="relative bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
      <h2 className="text-3xl font-bold text-center mb-6 ">Contact Us</h2>
      <form form ref={form} onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-3 border rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Message</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full p-3 border rounded-md h-32"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600/90 text-white p-3 rounded-md hover:bg-blue-900"
        >
          Send Message
        </button>
      </form>
    </div>
  </div>
)}